const Colors = [
    [
        "#000",
        "#eee",
        "#FABF01",
    ],
    [
        "#000",
        "#eee",
        "#efcc7c",
    ],
    [
        "#000",
        "#fff",
    ],
    [
        "#000",
        "#fff",
    ],
    [
        "#000",
        "#eee",
    ],
    [
        "#000",
        "#fff",
    ],
    [
        "#000",
        "#fff",
    ],
    [
        "#000",
        "#eee",
    ],
    [
        "#000",
        "#fff",
    ],
    [
        "#000",
        "#fff",
    ],
    [
        "#000",
        "#eee",
    ],
   
    [
        "#000",
        "#efcc7c",
        "#dddddd",
        "#dddddd",
        "#dddddd",
        "#dddddd",
    ],

    [
        "#000",
        "#FABF01",
        "#325FAF",
        "#8B7BA9",
        "#E92023",
        "#FAEAD1",
    ],
    [
        "#000",
        "#FABF01",
        "#325FAF",
        "#31987A",
        "#8B7BA9",
        "#E92023",
        "#FAEAD1",
    ],
    [
        "#000",
        "#FABF01",
        "#325FAF",
        "#41989A",
        "#8B7BA9",
        "#E92023",
        "#FAEAD1",
    ],
    [
        "#000",
        "#33BB70",
        "#0075CA",
        "#FDDC3F",
        "#FF6936",
    ],
    [
        "#000",
        "#f9cd22",
        "#3cb371",
        "#e94e19",
        "#cc0028",
    ],
    [
        "#000000",
        "#f1594a",
        "#24a160",
        "#acc1bc",
        "#d38e1a",
    ],
    [
        "#0a0a0a",
        "#FFFCC9",
        "#ED555D",
        "#41B797",
        "#7B5770",
        "#EDA126",
        "#7B5770",
    ],
    [
        "#0a0a0a",
        "#FFFCC9",
        "#ED555D",
        "#7B5770",
        "#EDA126",
        "#7B5770",
    ],
    [
        "#0a0a0a",
        "#FFFCC9",
        "#ED555D",
        "#7B5770",
        "#41B797",
        "#EDA126",
        "#7B5770",
    ],
    [
        "#0a0a0a",
        "#FFFCC9",
        "#ED555D",
        "#EDA126",
        "#7B5770",
    ],
    [
        "#000",
        "#CFC7B9",
        "#D1AF84",
        "#CEC8B8",
        "#F3B551",
        "#4AAD8B",
    ],
    // [
    //     "#000",
    //     "#ffffff",
    //     "#f0292f",
    //     "#fb6119",
    //     "#3e8741",
    // ],
    [
        "#000",
        "#ffffff",
        "#2969ee",
        "#efcc7c",
    ],
    [
        "#000000",
        "#f1594a",
        "#34a160",
    ],
    [
        "#020202",
        "#00BB70",
        "#0075CA",
        "#FDDC3F",
        "#FF6936",
    ],
    
    [
        "#000000",
        "#f1594a",
        "#24a160",
        "#acc1bc",
        "#d38e1a",
    ],
    [
        "#0a0a0a",
        "#FFFCC9",
        "#ED555D",
        "#41B797",
        "#EDA126",
        "#7B5770",
    ],
    [
        "#000",
        "#CFC7B9",
        "#D1AF84",
        "#CEC8B8",
        "#F3B551",
        "#4AAD8B",
    ],
    // [
    //     "#000",
    //     "#ffffff",
    //     "#f0292f",
    //     "#fb6119",
    //     "#3e8741",
    // ],
    [
        "#000",
        "#ffffff",
        "#2969ee",
        "#efcc7c",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [
        "#000000",
        "#F5D4BC",
        "#4E4973",
        "#CD902A",
        "#BF4A2B",
    ],
    [
        "#000000",
        "#F0F1F4",
        "#99673A",
        "#F6C0B3",
        "#F40104",
    ],
    [
        "#000000",
        "#F5D4BC",
        "#CD902A",
        "#BF4A2B",
    ],
    // [
    //     "#000000",
    //     "#ffffff",
    //     "#f0292f",
    //     "#fb6119",
    //     "#3e8741",
    // ],
    [
        "#000000",
        "#3e8740",
        "#fa3219",
        "#fca503",
        "#ffffff",
    ],
    [
        "#000000",
        "#3639e1",
        "#ebd999",
        "#9b5348",
        "#44693e",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
]
export default Colors